import request from '@/utils/request'

let PortApi = {

    /*渠道列表*/
    portList(data, errorback) {
        return request._post('/shop/plus.port.port/index', data, errorback);
    },

    /* 添加体验者 */
    addTester(data,errorback){
        return request._post('/shop/plus.port.port/addtester', data, errorback);
    },

    /* 解绑体验者 */
    deleteTester(data,errorback){
        return request._post('/shop/plus.port.port/deletetester', data, errorback);
    },
    /* 体验者列表 */
    testerList(data,errorback){
        return request._post('/shop/plus.port.port/testerlist', data, errorback);
    },
    
    /*端口详情  */
    portDetail(data,errorback){
        return request._post('/shop/plus.port.port/portDetail', data, errorback);
    },

    /*代码详情  */
    submitCode(data,errorback){
        return request._post('/shop/plus.port.port/submitCode', data, errorback);
    },

    /* 获取体验码 */
    getQrcode(data,errorback){
        return request._post('/shop/plus.port.port/getQrcode', data, errorback);
    },

    /* 
    *提交审核
    */
    auditCode(data,errorback){
        return request._post('/shop/plus.port.port/auditCode', data, errorback);
    },


    /* 获取授权url */
    authUrl(data,errorback){
        return request._post('/shop/plus.port.port/authUrl', data, errorback)
    },

    /* 获取授权url */
    getBaseData(data,errorback){
        return request._post('/shop/plus.port.port/getBaseData', data, errorback)
    },
    /* 发布代码 */
    releaseCode(data,errorback){
        return request._post('/shop/plus.port.port/releaseCode', data, errorback)
    },

    /* 查询详情*/
    detail(data,errorback){
        return request._get('/shop/plus.port.port/add', data, errorback)
    },
    /* 选择界面 */
    select(data,errorback){
        return request._get('/shop/plus.port.port/select', data, errorback)
    },
    add(data,errorback){
        return request._post('/shop/plus.port.port/add', data, errorback)
    },
    deletPort(data,errorback){
        return request._post('/shop/plus.port.port/deletPort', data, errorback)
    },
    /* 体验者列表 */
    versionList(data,errorback){
        return request._post('/shop/plus.port.port/versionList', data, errorback);
    },
    /* 同步列表 */
    syncCodeTemplate(data,errorback){
        return request._post('/shop/plus.port.port/codeTemplateList', data, errorback);
    }, 
}

export default PortApi;



// WEBPACK FOOTER //
// ./src/api/port.js